import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types'
import format from 'date-fns/format';
import _ from "lodash";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import BreadCrumbNav from '../BreadCrumbNav'
import './InstalledInfoSearch.css'
import { getUser,getUserSort,getComparator,stableSort,getFilterOptions } from '../../helpers';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });
const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#eee",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>

      <TableRow className="software-status">

        <TableCell align="center" style={{ width: 30 }}>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell component="th" scope="row">
          {row.app_name}
        </TableCell>

        <TableCell align="left">{row.publisher}</TableCell>

        <TableCell align="left">{row.install_time.substr(0, 10)}</TableCell>

        <TableCell align="left">{row.version_info}</TableCell>
        
      </TableRow>

      <TableRow>

        <TableCell className="software-history" colSpan={4}>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                履歴
              </Typography>

              <TableContainer component={Paper}>

                <Table size="small" aria-label="purchases">

                  <TableHead>

                    <TableRow>
                      <StyledTableCell>名前</StyledTableCell>
                      <StyledTableCell align="left">発行元	</StyledTableCell>
                      <StyledTableCell align="left">インストール日	</StyledTableCell>
                      <StyledTableCell align="left">バージョン</StyledTableCell>
                      
                    </TableRow>

                  </TableHead>

                  <TableBody>

                    {row.history.map((historyRow) => (

                      <TableRow key={historyRow.version_info}>

                        <TableCell component="th" scope="row">{historyRow.app_name}</TableCell>
                        <TableCell align="left">{historyRow.publisher}</TableCell>
                        <TableCell align="left">{historyRow.install_time.substr(0, 10)}</TableCell>
                        <TableCell align="left">{historyRow.version_info}</TableCell>

                      </TableRow>

                    ))}

                  </TableBody>

                </Table>
                
              </TableContainer>
            </Box>
          </Collapse>

        </TableCell>

      </TableRow>

    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    app_name: PropTypes.string.isRequired,
    install_time: PropTypes.string.isRequired,
    version_info: PropTypes.string.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        app_name: PropTypes.string.isRequired,
        install_time: PropTypes.string.isRequired,
        version_info: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

class InstalledInfoSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 100,
      date: null,
      user_name: null,
      user_id: null, 
      app_name : null,
      selected_app_name : null,
      pc_name: null,
      mac_add : null,
      open_detail: false,
      pc_selected: {},
      // data_details: [],
      // lastTime: '',
      order: "asc", 
      orderBy: "pc_name",
      firstLoad : true,
      // userNames: [], 
      // appNames: [],
      // pcNames: [],
    };
    this.debouncedFetchData = _.debounce(this.fetchData,500);
  }

  componentDidMount() {
    this.fetchData();
    this.fetchFilterData(); 
  }

  //サビースタグのサポート表示のURLを作成する関数
  functionUrlCreate = (strSereial = "") => {
    return "https://www.dell.com/support/home/en-vn/product-support/servicetag/" + strSereial + "/overview";
  }

  fetchData = () => {
    const { getInstalledInfoSearch } = this.props;
    const params = {
      user_name: this.state.user_name,
      pc_name: this.state.pc_name,
      app_name: this.state.app_name,
      user_id: this.state.user_id, 
      mac_add: this.state.mac_add,
      selected_app_name: this.state.selected_app_name,
      // offset: this.state.offset * this.state.limit, 
      // limit: this.state.limit,
      date: format(Date.now(), 'yyyy-MM-dd')
    };
    getInstalledInfoSearch(params);
  }

  fetchFilterData=()=>{
    const { getFilterDatas } = this.props;
    const params = {
      filter_items: ["installed_app"],
    };
    getFilterDatas(params);
  }

  handleClickDownloadCSV = (filteredItems) => {
    
    const csvRows = ["検索条件："];  
    if (this.state.pc_name === null) {
      csvRows.push("　端末番号: すべて");
    } else if (this.state.pc_name === "") {
      csvRows.push("　端末番号: 空白");
    } else {
      csvRows.push("　端末番号: " + this.state.pc_name);
    }

    if (this.state.user_name === null) {
      csvRows.push("　ユーザー名: すべて");
    } else if (this.state.user_name === "") {
      csvRows.push("　ユーザー名: 空白");
    } else {
      csvRows.push("　ユーザー名: " + this.state.user_name);
    }

    if (this.state.app_name === null) {
      csvRows.push("　ソフトウェア名: すべて");
    } else if (this.state.app_name === "") {
      csvRows.push("　ソフトウェア名: 空白");
    } else {
      csvRows.push("　ソフトウェア名: " + this.state.app_name);
    }

    const csvHeaderTitles = ["端末番号", "ユーザー名", "部署名", "メ一カ一名", "モデル名", "シリアルNo"];
    csvRows.push(csvHeaderTitles.join(','));
  
    filteredItems.forEach(item => {
      const row = [
        item.pc_name,
        item.user_name,
        item.section_name,
        item.manufacturer,
        item.system_model,
        item.serial_number,
      ];
      csvRows.push(row.map(v => `"${v.toString().replace(/"/g, '""')}"`).join(','));
    
  });
  
    const csvData = csvRows.join('\n');
    const BOM = '\uFEFF'; // BOM cho UTF-8
    const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });

    const date = new Date();
    const options = {
      timeZone: "Asia/Tokyo",
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, ''); 
    const filename = `ソフトウェアインストール状態_${formattedDate}.csv`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  changePagination = (event, newPage) => {
    const newOffset = newPage - 1;
    this.setState({
      offset: newOffset
    });
  };
  
  // 詳細データ設定
  setDetailDatas=(data_details)=>{
      const app_names = _.sortBy(data_details, ["app_name", "install_time"]);
      let data_details_rows = {};
      for(let i=0; i<app_names.length; i++){
        let isDuplicate = false;
        const key = app_names[i].app_name;
        if (!data_details_rows[key]) {
          data_details_rows[key] = [];
        } else {
          // 重複確認
          const duplicates = data_details_rows[key];
          for(let d=0; d<duplicates.length; d++){
            if ((duplicates[d].install_time.substr(0, 10) === app_names[i].install_time.substr(0, 10)) && (duplicates[d].version_info === app_names[i].version_info)) {
              isDuplicate = true;
              break;
            }}
        }
        if (!isDuplicate) {
          data_details_rows[key].push(app_names[i]);
        }
      }
  
      const data_key = Object.keys(data_details_rows);
      let datas = [];
      for(let i=0; i<data_key.length; i++){
        const key = data_key[i];
        const details = data_details_rows[key];
        const detail_last = details.slice(-1)[0];
        datas.push({...detail_last, history: _.reverse(_.sortBy(details, ["install_time"]))})
      }
      
      return datas;
    }

  render() {
    const user = getUser();
    const {data_details, filterDatas, items, isFetching,lastUpdated } = this.props
    // const { limit, offset } = this.state;
    
    const filteredItems = items
      ? ( stableSort(items.detailData || [], getComparator(this.state.order, this.state.orderBy))
        ).filter( (item) =>{
          return ( 
          ( this.state.user_name === null ? true : this.state.user_name === "" ? item.user_name === "" 
            : this.state.user_id !== null ? item.user_id === this.state.user_id
            : item.user_name && item.user_name.includes(this.state.user_name)
          ) &&
          ( this.state.pc_name === null ? true : this.state.pc_name === "" ? item.pc_name === "" 
            : this.state.mac_add !== null ? item.mac_add === this.state.mac_add
            : item.pc_name && item.pc_name.includes(this.state.pc_name)
          )
          )})
        : [];
    
    // フィルターデータ設定
    let user_options,pc_spec_options,app_name_options;
    if (filteredItems.length >0){
      user_options=getFilterOptions(filteredItems,["user_id","user_name"],"user_name","user_name")
                  .sort((a, b) => a.user_name.localeCompare(b.user_name, undefined, {sensitivity: "base", numeric: true}));

      pc_spec_options=getFilterOptions(filteredItems,["mac_add","pc_name"],"pc_name","pc_name")
                  .sort((a, b) => a.pc_name.localeCompare(b.pc_name, undefined, {sensitivity: "base", numeric: true}));
    }

    app_name_options=filterDatas?filterDatas.installed_app||[]:[];
    
    // const displayedItems = sortedItems.slice(offset * limit, (offset + 1) * limit);
    const displayedItems = filteredItems.slice(this.state.offset * this.state.limit, (this.state.offset + 1) * this.state.limit);

    const createSortHandler = (property) => (event) => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      const order = {order: isAsc ? 'desc' : 'asc'};
      this.setState(order);

      const orderBy = {orderBy: property};
      this.setState({
        ...order,
        ...orderBy,
        i_num: -1,
        firstLoad: false,
      });
      localStorage.setItem('setting-user-sort', JSON.stringify({...order, ...orderBy}));
    };
    
    const handleClickOpenDetail = (event) => {
      event.currentTarget.blur(); 
      console.log(JSON.parse(event.currentTarget.value));
      const { getInstalledInfoDetails } = this.props
      const params = JSON.parse(event.currentTarget.value);
      this.setState({ pc_selected: params,open_detail:true});
      getInstalledInfoDetails(params);
    };

    const handleCloseDetail = () => {
      this.setState({open_detail: false, data_details: []});
    };

    // フィルターデータ変更時の処理
    const handleChangeFilter = (filterDict) => {
      const { changeFilterDatas } = this.props
      this.setState({ ...this.state,firstLoad: false,...filterDict});
      changeFilterDatas({...filterDict});
    };

    return (
      <div className="content-container">

        {this.state.firstLoad && isFetching ? <div className='loading'>お待ちください．．．</div>
          :<>

            <BreadCrumbNav screenName="ソフトウェアインストール状態"></BreadCrumbNav>

            <div className="loginname">ログイン名：{user.username}</div>

            <div className="filter-container-search">

              <FormControl className="forminstalledinfosearch-filter">
                <Autocomplete
                  freeSolo
                  id="combo-box-autocomplete-pc_name"
                  className="combo-box-autocomplete-installedinfosearch"
                  value={this.state.pc_name}
                onChange={(event, newValue) => {
                if (!newValue) {
                  handleChangeFilter({
                    pc_name: null,
                    mac_add: null,
                    firstLoad: false,
                    offset: 0
                  });
                } else {
                  handleChangeFilter({
                    pc_name: newValue?.pc_name ?? "",
                    mac_add: null,
                    firstLoad: false,
                    offset: 0
                  });
                }
              }}
                onInputChange={(event, value) => {
                if (event && event.type === "change") {
                  handleChangeFilter({pc_name:value,mac_add:null, firstLoad: false , offset: 0});
                  }
                }}
                options={
                  this.state.pc_name && this.state.pc_name.trim() !== "" && pc_spec_options
                    ? pc_spec_options.filter(item => item.pc_name.toLowerCase().includes(this.state.pc_name.toLowerCase()))
                    : pc_spec_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.pc_name || ''
                }
                renderInput={(params) => (
                <TextField
                  {...params}
                  className="autocomplete-filter"
                  label="端末番号："
                  variant="outlined"
                  fullWidth
                />
                )}
                />
              </FormControl>
              
              <FormControl className="forminstalledappstatus-filter">
                <Autocomplete
                freeSolo
                id="combo-box-autocomplete-user_name"
                className="combo-box-autocomplete-installedappstatus"
                value={this.state.user_name}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      user_name: null,
                      user_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      user_id: newValue.user_id ?? null,
                      user_name: newValue.user_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({user_name:value,user_id:null,firstLoad: false , offset: 0 });
                  }
                }}
                options={
                  this.state.user_name && this.state.user_name.trim() !== "" && user_options
                    ? user_options.filter(item => item.user_name.toLowerCase().includes(this.state.user_name.toLowerCase()))
                    : user_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.user_name || ''
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="autocomplete-filter"
                    label="ユーザー名："
                    variant="outlined"
                    fullWidth
                  />
                )}
                />
              </FormControl>

              <FormControl className="forminstalledinfosearch-filter">
                <Autocomplete
                  freeSolo
                  id="combo-box-autocomplete-app_name"
                  className="combo-box-autocomplete-installedinfosearch"
                  value={this.state.app_name}
                  onChange={(event, newValue) => {
                    this.setState({ app_name: newValue , selected_app_name: newValue, firstLoad: false , offset: 0 }, () => {
                      this.debouncedFetchData(); 
                    });
                    // handleChangeFilter({app_name:newValue?newValue:null,selected_app_name: newValue?newValue:null, firstLoad: false , offset: 0});
                  }}
                  onInputChange={(event, value) => {
                    if (event && event.type === "change") {
                      // handleChangeFilter({app_name:value,selected_app_name:null,firstLoad: false , offset: 0 });
                      this.setState({ app_name: value, firstLoad: false }, () => {
                        this.debouncedFetchData();
                      })
                    }
                  }}
                  options={
                    this.state.app_name && this.state.app_name.trim() !== "" && app_name_options
                      ? app_name_options.filter(item => item.toLowerCase().includes(this.state.app_name.toLowerCase()))
                      : app_name_options || []
                  }
                  getOptionLabel={(option) => 
                    typeof option === 'string' ? option : option || ''
                  }

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="autocomplete-filter"
                      label="ソフトウェア名："
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </FormControl>


              <FormControl className="installedinfosearch-download">
              <Button
                variant="contained"
                color="primary"
                className="download-button"
                onClick={() => this.handleClickDownloadCSV(filteredItems)}
                disabled={!this.props.items || this.props.items.length === 0}
              >
                ダウンロード
              </Button>
              </FormControl>

              <div className='installInfoSearch-item-count'>
                <b>検索結果：{filteredItems.length}件 </b>
              </div>

            </div>

            <Paper className="table-root">

              <TableContainer className="table-container-search">

                <Table stickyHeader aria-label="sticky table">

                  <TableHead>
                    
                    <TableRow>

                      <TableCell 
                        key="pc_name"
                        align="center" 
                        sortDirection={this.state.orderBy === "pc_name" ? this.state.order : false}
                        style={{ minWidth: 120 }}
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "pc_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("pc_name")}
                        >
                          端末番号
                          {this.state.orderBy === "pc_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                      </TableCell>

                      <TableCell 
                        key="user_name"
                        align="center" 
                        sortDirection={this.state.orderBy === "user_name" ? this.state.order : false}
                        style={{ minWidth: 120 }}
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "user_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("user_name")}
                        >
                          ユーザー名
                          {this.state.orderBy === "user_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                      </TableCell>

                      <TableCell 
                        key="section_name"
                        align="center" 
                        sortDirection={this.state.orderBy === "section_name" ? this.state.order : false}
                        style={{ minWidth: 120 }}
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "section_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("section_name")}
                        >
                          部署名
                          {this.state.orderBy === "section_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                      </TableCell>

                      <TableCell colSpan={3} align="center" style={{ minWidth: 370 }}>PC情報<br/>メ一カ一名 ・ モデル名 ・ シリアルNo.</TableCell>

                      <TableCell align="center" style={{ minWidth: 50 }}></TableCell>

                    </TableRow>

                  </TableHead>

                  <TableBody>
                    {displayedItems.map((item, index) => {
                      if ((!this.state.app_name || this.state.app_name === item.app_name || !item.app_name)) {
                          return (
                          <TableRow key={index}>
                            <TableCell align="center" component="th" scope="row">{item.pc_name}</TableCell>
                            <TableCell align="center">{item.user_name}</TableCell>
                            <TableCell align="center">{item.section_name}</TableCell>
                            <TableCell align="center">{item.manufacturer}</TableCell>
                            <TableCell align="center">{item.system_model}</TableCell>
                              {(item.manufacturer.includes("Dell Inc.")&&regex.test(item.serial_number)===false&&item.serial_number.length===7) ?
                                <TableCell align="center">
                                  <a href={this.functionUrlCreate(item.serial_number)} target="_blank" rel="noopener noreferrer">
                                    {item.serial_number}
                                  </a>
                                </TableCell> :
                                
                                <TableCell align="center">{item.serial_number}</TableCell>
                              }

                            <TableCell align="center">
                              <Button variant="outlined" color="primary" value={JSON.stringify({pc_name: item.pc_name, user_name: item.user_name, mac_add: item.mac_add})} 
                                onClick={handleClickOpenDetail}>詳細
                              </Button>
                            </TableCell>
                          </TableRow>
                          );
                        }
                      // return null; 
                    })}
                  </TableBody>

                </Table>
            
              </TableContainer>
              { filteredItems.length > 0 && 
                <div className='pagination-button'>
                  <Pagination
                    page={this.state.offset + 1}
                    count={Math.ceil(filteredItems.length / this.state.limit)}
                    onChange={this.changePagination}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                  />
                </div>
              }
            </Paper>
          </>
        }

        <Dialog fullScreen open={this.state.open_detail} onClose={handleCloseDetail}>

          <AppBar style={{ position: 'relative' }}>

            <Toolbar>
              <Typography edge="start" variant="h6" style={{ marginLeft: 2, flex: 1 }}>
                ソフトウェアインストール状態
              </Typography>

              <Typography variant="h6" style={{ marginLeft: 2, flex: 1 }}>
                端末番号：{this.state.pc_selected.pc_name}
              </Typography>

              <Typography variant="h6" style={{ marginLeft: 2, flex: 1 }}>
                ユーザー名：{this.state.pc_selected.user_name}
              </Typography>

              <IconButton color="inherit" onClick={handleCloseDetail} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>

          </AppBar>

          <div style={{ textAlign:'right', height: 48, flex: 1 }}>
            <Typography style={{ lineHeight: 2, fontSize:24, paddingRight: 10 }}>{`(最新)データ取得日時: ${lastUpdated}`}</Typography>
          </div>

          <div style={{ height:"100%" }}>

            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">

                <TableHead>

                  <TableRow>

                    <TableCell/>
                    {/* <TableCell>名前</TableCell> */}
                    <TableCell 
                        key="app_name"
                        
                        sortDirection={this.state.orderBy === "app_name" ? this.state.order : false}
                        
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "app_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("app_name")}
                        >
                          名前
                          {this.state.orderBy === "app_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                    </TableCell>
                    <TableCell 
                        key="publisher"
                        align="left" 
                        sortDirection={this.state.orderBy === "publisher" ? this.state.order : false}
                        
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "publisher" ? this.state.order : 'asc'}
                          onClick={createSortHandler("publisher")}
                        >
                          発行元
                          {this.state.orderBy === "publisher" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                    </TableCell>
                    <TableCell align="left">インストール日</TableCell>
                    <TableCell 
                        key="version_info"
                        sortDirection={this.state.orderBy === "version_info" ? this.state.order : false}
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "version_info" ? this.state.order : 'asc'}
                          onClick={createSortHandler("version_info")}
                        >
                          バージョン
                          {this.state.orderBy === "version_info" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                    </TableCell>
                    
                  </TableRow>

                </TableHead>

                <TableBody>
                  {stableSort(this.setDetailDatas(data_details), getComparator(this.state.order, this.state.orderBy))
                                  .map((item, index) => (
                                    <Row key={index} row={item} />
                                ))}
                </TableBody>

              </Table>
            </TableContainer>

          </div>

        </Dialog>

      </div>
    );
  }
}

InstalledInfoSearch.propTypes = {
  getInstalledInfoSearch: PropTypes.func.isRequired,
  getInstalledInfoDetails: PropTypes.func.isRequired,
  getFilterDatas: PropTypes.func.isRequired,
  changeFilterDatas: PropTypes.func.isRequired,
};

export default InstalledInfoSearch;